var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5007 7.00005C16.5007 6.44776 16.9484 6.00005 17.5007 6.00005C18.053 6.00005 18.5007 6.44776 18.5007 7.00005C18.5007 7.55233 18.053 8.00005 17.5007 8.00005C16.9484 8.00005 16.5007 7.55233 16.5007 7.00005Z",
    fill: "#0066CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5007 7.25005C9.87732 7.25005 7.75067 9.37669 7.75067 12C7.75067 14.6234 9.87732 16.75 12.5007 16.75C15.124 16.75 17.2507 14.6234 17.2507 12C17.2507 9.37669 15.124 7.25005 12.5007 7.25005ZM9.25067 12C9.25067 10.2051 10.7057 8.75005 12.5007 8.75005C14.2956 8.75005 15.7507 10.2051 15.7507 12C15.7507 13.795 14.2956 15.25 12.5007 15.25C10.7057 15.25 9.25067 13.795 9.25067 12Z",
    fill: "#0066CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7589 2.83306C14.2924 2.44562 10.709 2.44562 7.24244 2.83306C5.23038 3.05794 3.60605 4.64295 3.3695 6.66548C2.95496 10.2098 2.95496 13.7903 3.3695 17.3346C3.60605 19.3571 5.23038 20.9422 7.24244 21.167C10.709 21.5545 14.2924 21.5545 17.7589 21.167C19.771 20.9422 21.3953 19.3571 21.6319 17.3346C22.0464 13.7903 22.0464 10.2098 21.6319 6.66548C21.3953 4.64295 19.771 3.05794 17.7589 2.83306ZM7.40905 4.32378C10.7649 3.94871 14.2365 3.94871 17.5923 4.32378C18.9224 4.47244 19.9879 5.52205 20.142 6.83973C20.543 10.2683 20.543 13.7318 20.142 17.1604C19.9879 18.478 18.9224 19.5277 17.5923 19.6763C14.2365 20.0514 10.7649 20.0514 7.40905 19.6763C6.07894 19.5277 5.01346 18.478 4.85934 17.1604C4.45834 13.7318 4.45834 10.2683 4.85934 6.83973C5.01346 5.52205 6.07894 4.47244 7.40905 4.32378Z",
    fill: "#0066CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.0d9e976ba9b28658b4aeeaa766e1f84e.svg";
export { ForwardRef as ReactComponent };